const $ = require('jquery')

function init (shareButton) {
  const shareMethodsUrl = $(shareButton).parent().parent().parent().attr('data-url').replace(':443', '')
  const shareMethodsUrlEncoded = encodeURIComponent(shareMethodsUrl)
  const shareMethodsTitle = encodeURIComponent($(shareButton).parent().parent().parent().attr('data-text'))

  // Twitter
  let shareURLTwitter = null
  const shareMethodsVia = $(shareButton).parent().parent().parent().attr('data-via')
  const shareMethodsHashtags = $(shareButton).parent().parent().parent().attr('data-hashtags')
  const _shareURLTwitter = `${shareMethodsUrlEncoded}&text=${shareMethodsTitle}&url=${shareMethodsUrlEncoded}`

  if (shareMethodsVia != null || shareMethodsHashtags != null) {
    if (shareMethodsVia != null && shareMethodsHashtags == null) {
      shareURLTwitter = `${_shareURLTwitter}&via=${shareMethodsVia}`
    } else if (shareMethodsVia === null && shareMethodsHashtags != null) {
      shareURLTwitter = `${_shareURLTwitter}&hashtags=${shareMethodsHashtags}`
    } else if (shareMethodsVia != null && shareMethodsHashtags != null) {
      shareURLTwitter = `${_shareURLTwitter}&via=${shareMethodsVia}&hashtags=${shareMethodsHashtags}`
    }
  } else {
    shareURLTwitter = _shareURLTwitter
  }

  if ($(shareButton).hasClass('twitter-share')) {
    $(shareButton).attr('href', `https://twitter.com/intent/tweet?original_referer=${shareURLTwitter}`)
  }

  if ($(shareButton).hasClass('fb-share')) {
    $(shareButton).attr('href', `http://www.facebook.com/share.php?u=${shareMethodsUrlEncoded}`)
  }
  if ($(shareButton).hasClass('google-share')) {
    $(shareButton).attr('href', `https://plus.google.com/share?url=${shareMethodsUrlEncoded}`)
  }

  $(shareButton).click(function() {
    const popupWidth = 480
    const popupHeight = 320
    const left = (screen.width / 2) - (popupWidth / 2)
    const top = (screen.height / 2) - (popupHeight / 2)

    window.open($(shareButton).attr('href'), '_blank', `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=${popupHeight},width=${popupWidth},left=${left},top=${top}`)

    return false
  })
}

module.exports = {
  init,
}



// WEBPACK FOOTER //
// ./src/modules/socialButtons.js